<template>
  <div class="app-navbar-actions">
    <div v-if="authStore.user" class="mr-2 md:mr-4 text-right leading-tight hidden md:block">
      <div class="font-semibold text-xs md:text-sm">{{ authStore.user.first_name || authStore.user.username }}</div>
    </div>
    <NotificationDropdown class="app-navbar-actions__item" />
    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-1" />
  </div>
</template>

<script lang="ts" setup>
import { useAuthStore } from '../../../stores/auth'
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import NotificationDropdown from './dropdowns/NotificationDropdown.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const authStore = useAuthStore()
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media screen and (max-width: 768px) {
    gap: 0.5rem;
  }

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }

  &__item {
    padding: 0;
    margin-left: 0;
    margin-right: 0;
    transition: all 0.3s ease;

    svg {
      height: 18px;
      transition: all 0.3s ease;

      @media screen and (max-width: 768px) {
        height: 16px;
      }
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    :deep(.va-dropdown-content) {
      background-color: var(--va-white);
    }

    &:hover svg {
      transform: scale(1.1);
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }

  > div {
    display: flex;
    align-items: center;
    gap: inherit;

    > * {
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
      }
    }
  }
}
</style>
